import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import api from 'src/axios';

type SkipProductForecastProps = {
  sessionId: string;
  sku: string;
};

export const useSkipProductForecast = (
  options?: Omit<
    UseMutationOptions<void, Error, SkipProductForecastProps>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, SkipProductForecastProps> => {
  return useMutation({
    mutationFn: async ({ sessionId, sku }: SkipProductForecastProps) => {
      const { data } = await api.put(
        `/sales-forecasting-sessions/${sessionId}/products/${sku}/skip`,
      );
      return data;
    },
    ...options,
  });
};
